module.exports = require('./helpers/bundle-url').getBundleURL('6XBEJ') + "logo.c51670a8.svg";